export default __webpack_public_path__ + "static/media/ck.2f409655.svg";